import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=2d0b4ad1&scoped=true"
import script from "./taskList.vue?vue&type=script&lang=js"
export * from "./taskList.vue?vue&type=script&lang=js"
import style0 from "./taskList.vue?vue&type=style&index=0&id=2d0b4ad1&scoped=true&lang=css"
import style1 from "./taskList.vue?vue&type=style&index=1&id=2d0b4ad1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b4ad1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d0b4ad1')) {
      api.createRecord('2d0b4ad1', component.options)
    } else {
      api.reload('2d0b4ad1', component.options)
    }
    module.hot.accept("./taskList.vue?vue&type=template&id=2d0b4ad1&scoped=true", function () {
      api.rerender('2d0b4ad1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/myTask/taskList.vue"
export default component.exports